import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';

import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { authHttpInterceptorFn, provideAuth0 } from '@auth0/auth0-angular';
import { environment } from 'src/environments/environment';
import { routes } from './app.routes';
import { DemographicService } from './utils/services/demographic';
import { errorHandlerInterceptor } from './utils/services/error-handler-interceptor';

const EXCLUDED_AUTH_URIS = [
  `${environment.BASE_API}/v1/quotes/corporative-even`,
  `${environment.BASE_API}/v1/quotes/culinary-adventur`,
  `${environment.BASE_API}/v1/quotes/cooking-clas`,
  `${environment.BASE_API}/v1/quotes/personal-chef`,
  `${environment.BASE_API}/v1/quotes/secret-garde`,
  `${environment.BASE_API}/v1/busines`,
  `${environment.BASE_API}/v1/products`,
  `${environment.BASE_API}/v1/meal-styles`,
  `${environment.BASE_API}/v1/shipping-zones`,
  DemographicService.BASE_API,
  '/mock',
];

export const appConfig: ApplicationConfig = {
  providers: [
    // {
    //   provide: ErrorHandler,
    //   useValue: createErrorHandler(),
    // },
    // {
    //   provide: TraceService,
    //   deps: [Router],
    // },
    // provideAppInitializer(() => {
    //   inject(TraceService);
    // }),
    provideAnimations(),
    provideHttpClient(
      withFetch(),
      withInterceptors([authHttpInterceptorFn, errorHandlerInterceptor]),
    ),
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
    ),
    provideAuth0({
      domain: environment.AUTH0_DOMAIN,
      clientId: environment.AUTH0_CLIENT_ID,
      authorizationParams: {
        redirect_uri: window.location.origin,
        scope: 'openid profile email',
        audience: environment.AUTH0_AUDIENCE_DOMAIN,
      },
      httpInterceptor: {
        allowedList: [
          {
            uriMatcher: (uri) =>
              !EXCLUDED_AUTH_URIS.some((excludedUri) => uri.startsWith(excludedUri)),
          },
        ],
      },
    }),
  ],
};
